<div mat-dialog-title class="text-center mb-0 fw-bold mt-3">
    <mat-icon class="w-25 h-100" [svgIcon]="calIcon"></mat-icon>
</div>

<mat-divider></mat-divider>

<mat-dialog-content>
    <div class="container-fluid p-2">
        <div class="row" [formGroup]="calForm">
            <mat-form-field appearance="outline" class="w-100 mb-3">
                <mat-label>Name</mat-label>
                <mat-error>You need to enter a name</mat-error>
                <input matInput placeholder="" formControlName="name" required>
                <mat-hint>Enter any name for your integration</mat-hint>
            </mat-form-field>

            <mat-form-field appearance="outline" class="w-100 mb-3">
                <mat-label>Username</mat-label>
                <mat-error>You need to enter your username</mat-error>
                <input matInput placeholder="" formControlName="username" required>
                <mat-hint>Enter your Cal username</mat-hint>
            </mat-form-field>

            <mat-form-field appearance="outline" class="w-100 mb-3">
                <mat-label>Event Id</mat-label>
                <mat-error *ngIf="calForm.controls['eventId'].hasError('required')">You need to enter an event Id</mat-error>
                <mat-error *ngIf="calForm.controls['eventId'].hasError('minLength') || calForm.controls['eventId'].hasError('maxLength')">length of event id must be 6</mat-error>
                <input matInput type="number" placeholder="Ex: 485578" formControlName="eventId" required>
                <mat-hint>Enter the name of the event from your Cal account</mat-hint>
            </mat-form-field>

            <mat-form-field appearance="outline" class="w-100 mb-3">
                <mat-label>Api key</mat-label>
                <mat-error>You need to enter your Cal api key</mat-error>
                <input matInput placeholder="" formControlName="apiKey" required>
                <mat-hint>Enter the api key from you Cal account</mat-hint>
            </mat-form-field>

            <mat-form-field appearance="outline" class="w-100 mb-3">
                <mat-label>Timezone</mat-label>
                <mat-error *ngIf="calForm.controls['timezone'].hasError('required')">You need to enter your timezone</mat-error>
                <mat-error *ngIf="calForm.controls['timezone'].hasError('timezone')">timezone is not valid</mat-error>
                <input matInput placeholder="Ex: America/New_York" formControlName="timezone" [matAutocomplete]="auto" required>
                <mat-autocomplete #auto="matAutocomplete">
                    @for (option of filteredOptions | async; track option) {
                      <mat-option [value]="option">{{option}}</mat-option>
                    }
                  </mat-autocomplete>
                <mat-hint>Enter the time zone for your appointments</mat-hint>
            </mat-form-field>
        </div>
    </div>
</mat-dialog-content>

<mat-divider></mat-divider>

<mat-dialog-actions class="d-flex mt-1 justify-content-around">
    <button mat-dialog-close mat-raised-button class="w-25" color="warn" [disabled]="isLoading">Close</button>
    <button (click)="onAdd()" mat-raised-button class="w-25" color="primary" [disabled]="!calForm.valid || isLoading">
        <span *ngIf="!isLoading">
            {{isEditing ? 'Save' : 'Add'}}
        </span>
        <mat-spinner *ngIf="isLoading" [diameter]="30" [strokeWidth]="3" class="mx-auto mat-spinner"></mat-spinner>
        </button>
</mat-dialog-actions>